import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

console.log("Veronika Valova - Chopin Eterno v20260525134101"); // cache-refresh
const container = document.getElementById("root");

if (container.hasChildNodes()) {
  // HTML pre-renderizado por react-snap → hidratar
  hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
  
  // Durante el snapshot de react-snap: asegurar que Framer Motion
  // haya revelado todos los elementos antes del snapshot final
  if (navigator.userAgent === "ReactSnap") {
    // Hacer scroll completo para activar animaciones whileInView
    window.scrollTo(0, document.body.scrollHeight);
    
    // Esperar y luego revelar elementos ocultos por animaciones
    var reveal = function() {
      var els = document.querySelectorAll('[style*="opacity: 0"], [style*="opacity:0"]');
      for (var i = 0; i < els.length; i++) {
        els[i].style.opacity = "1";
        els[i].style.transform = "none";
      }
    };
    
    setTimeout(reveal, 100);
    setTimeout(reveal, 500);
    setTimeout(reveal, 1000);
    setTimeout(reveal, 2000);
    setTimeout(function() { window.scrollTo(0, 0); }, 3000);
  }
} else {
  // Modo normal (desarrollo)
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
